import styled from 'styled-components'

export const Person = ({
  data,
  colorMode,
}: {
  data: { [key: string]: any }
  colorMode: 'light' | 'dark' | undefined
}) => {
  return (
    <PersonRoot>
      <PersonHeader>
        <PersonData>
          <Persontitle>{data.name}</Persontitle>{' '}
          <PersonFact>{data.age} Jahre alt</PersonFact>
          <PersonFact>{data.position}</PersonFact>
          <PersonFact>Im Amt seit {data.since}</PersonFact>
          <PersonFact>{data.party}</PersonFact>
        </PersonData>
        <PersonImage>
          <img src={data.img} />
        </PersonImage>

        <svg
          id='Ebene_1'
          data-name='Ebene 1'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 30 23.05'
        >
          <polygon
            points='0 0 30 25 10 25 0 0'
            fill='var(--site-background)'
            // fill={colorMode === 'dark' ? 'var(--gray-2)' : 'var(--beige-bright-3)'}
          />
        </svg>
      </PersonHeader>
      <BG colorMode={colorMode}>{data.text}</BG>
    </PersonRoot>
  )
}

const PersonRoot = styled.div.attrs({ className: 'PersonRoot' })`
  overflow-x: hidden;
`

const PersonHeader = styled.div.attrs({ className: 'PersonHeader' })`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  line-height: 0;
  position: relative;
  height: 350px;
  background-color: var(--beige-bright-2);
  color: var(--brandblue-main);
  padding-top: 30px;
  border-radius: 8px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  margin-bottom: 15px;
  svg {
    position: absolute;
    width: 100px;
    bottom: 0;
    left: 42%;
  }

  @media screen and (max-width: 711px) {
    height: unset;
  }
`
const PersonData = styled.div`
  position: absolute;
  bottom: 120px;
  right: 0;
  width: calc(60% - 80px);
  padding-left: 80px;
  max-width: calc(100vw - 30px);
  overflow-x: hidden;
  flex: 0 0 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  align-items: left;
  flex-direction: column;

  @media screen and (max-width: 711px) {
    position: relative;
    left: unset;
    top: unset;
    bottom: unset;
    max-width: calc(100vw - 0px);

    width: calc(100% - 0px);
    padding-left: 0px;
    padding-top: 15px;
    padding-bottom: 30px;
    text-align: center;
    /* background-color: var(--brandblue-main); */
    /* color: #fff; */
  }
`

const BG = styled.div<{ colorMode: 'light' | 'dark' | undefined }>`
  font-family: var(--font-serif);
  /* background-color: var(--beige-bright-2);
  color: var(--brandblue-main);
  background-color: #fff;
  background-color: var(--beige-bright-2);
  background-color: var(--gray-6); */
  color: var(--text-color);
  background-color: var(--panel-color);
  /* props.colorMode === 'dark' ? 'var(--gray-2)' : 'var(--beige-bright-3)'}; */
  padding: 15px;
  padding-top: 0;
`

const PersonImage = styled.div`
  position: absolute;
  bottom: 0;
  left: 0%;
  flex: 0 0 100vw;
  text-align: left;
  overflow: hidden;
  height: 350px;
  text-align: left;
  img {
    margin-left: auto;
    margin-right: auto;
    max-width: 350px;
  }
  @media screen and (max-width: 711px) {
    flex: 0 0 100%;
    position: relative;
    height: unset;
    top: unset;

    transform: unset;

    img {
      max-width: unset;
      width: 80vw;
      margin-left: auto;
      margin-right: auto;
    }
  }
`
const Persontitle = styled.div`
  font-size: 18px;
  line-height: 1.4em;
  text-align: left;
  padding-left: 20px;
  margin-bottom: 20px;
  b {
    line-height: 1.4em;
    font-size: 22px;
    font-size: 18px;
  }

  @media screen and (max-width: 711px) {
    text-align: center;
  }
`
const PersonLevel = styled.div`
  text-align: left;
  padding-left: 20px;
  font-family: var(--font-sans-serif);
  font-size: 15px;
  font-weight: 300;
  letter-spacing: 0.5px;
  line-height: 1.3em;
  margin-bottom: 10px;
`
const PersonFact = styled.div`
  padding-left: 20px;
  text-align: left;
  line-height: 1.4em;
  font-family: var(--font-sans-serif);
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 0.75px;
  font-weight: 300;
  @media screen and (max-width: 711px) {
    text-align: center;
  }
  span {
    font-size: 14px;
    display: inline-block;
    opacity: 0.6;
  }
`
